import type {
  DocumentUploadConfigError,
  DocumentUploadError,
  DocumentUploadRequestError,
  GenericDocumentUploadError,
} from "@highnoteplatform/types";

const isError = (error: unknown): error is DocumentUploadError =>
  error !== null &&
  error !== undefined &&
  typeof error === "object" &&
  "name" in error &&
  "message" in error;

export const generateDocumentUploadConfigurationError = (
  message: string
): DocumentUploadConfigError => ({
  name: "DocumentUploadConfigError",
  message,
});

export const generateDocumentUploadRequestError = (
  message: string
): DocumentUploadRequestError => ({
  name: "DocumentUploadRequestError",
  message,
});

export const generateGenericDocumentUploadError = (
  message: string
): GenericDocumentUploadError => ({
  name: "GenericDocumentUploadError",
  message,
});

export const mapError = (
  error: unknown,
  onError: (error: DocumentUploadError) => void
) => {
  if (isError(error)) {
    if (
      error.name === "DocumentUploadConfigError" ||
      error.name === "DocumentUploadRequestError" ||
      error.name === "InvalidCredentialError"
    ) {
      onError(error);
    } else {
      onError(generateGenericDocumentUploadError(error.message));
    }
  } else {
    onError(generateGenericDocumentUploadError("Unknown error."));
  }
};
